import React from 'react';
/**
 * Use in case we need to pass props to children.
 * @param childrenProps React children
 * @param propsOrCallback this could be an object or a callback with the index as a parameter
 */
const usePassPropsToChildren = (childrenProps, propsOrCallback) => {
    const children = React.Children.map(childrenProps, (child, index) => React.cloneElement(child, typeof propsOrCallback === 'function'
        ? propsOrCallback(index)
        : propsOrCallback));
    return { children };
};
export default usePassPropsToChildren;
//# sourceMappingURL=usePassPropsToChildren.js.map